import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';


const exerciseNameMapping = {
  "Cat stretch": "מתיחת חתול",
  "Dumbbell Bicep Curl:": "כפיפת מרפקים עם משקולת",
  "Dumbbell Hammer Curl": "כפיפת מרפקים פטיש עם משקולת",
  "Prone abdominal stretch": "מתיחת בטן בשכיבה על הבטן",
  "Chest and biceps stretch": "מתיחת חזה ושרירי יד קדמיים",
  "Standing quadriceps stretch": "מתיחת ארבע ראשי בעמידה", // Changed from "רגל קדמית" to be more specific
  "Lying glute stretch": "מתיחת ישבן בשכיבה",
  "Bent-over barbell row": "חתירה עם מוט בעמידה כפופה",
  "Twisting hip extension": "הארכת ירך עם סיבוב",
  "Smith machine bent-knee good morning": "בוקר טוב עם מכונת סמית' וברכיים כפופות",
  "Machine back extension": "הארכת גב במכונה",
  "Good morning": "בוקר טוב",
  "Bird dog": "ציפור-כלב",
  "Superman": "סופרמן",
  "Assisted Chin Tuck": "טאק סנטר בסיוע",
  "Weighted Lying Neck Flexion (with head harness)": "כפיפת צוואר משוקללת בשכיבה (עם רתמה)",
  "Weighted Lying Neck Extension (with head harness)": "הארכת צוואר משוקללת בשכיבה (עם רתמה)",
  "Stability ball wall squat": "סקווט קיר עם כדור יציבות",
  "Bodyweight squat": "סקווט עם משקל גוף",
  "Dumbbell deadlift": "דדליפט עם משקולות יד",
  "Zercher squat": "סקווט זרשר",
  "Barbell front box squat": "סקווט קדמי לקופסה עם מוט", // Adjusted "על קופסה" to "לקופסה" for clarity
  "Barbell front squat": "סקווט קדמי עם מוט",
  "Barbell Bulgarian split squat": "סקווט מפוצל בולגרי עם מוט",
  "Dumbbell one-leg split squat": "סקווט מפוצל חד-רגלי עם משקולת",
  "Barbell side lunge": "לאנג' צידי עם מוט",
  "Cable hip abduction": "הרחקת ירך עם כבל",
  "Raised knee walking": "הליכה עם הרמת ברכיים",
  "Lateral leg raises": "הרמות רגל צידיות",
  "Standing Hip Abduction": "הרחקת ירך בעמידה",
  "Trap bar deadlift": "דדליפט עם מוט טרפז",
  "Dumbbell step-up": "עליית מדרגה עם משקולת",
  "Barbell one-leg hip thrust": "דחיפת ירך חד-רגלית עם מוט",
  "Barbell hip thrust": "דחיפת ירך עם מוט",
  "Weighted one-leg hip thrust": "דחיפת ירך חד-רגלית משוקללת",
  "Dirty Dog": "כלב מלוכלך",
  "Side Lying Clam Hips": "צדפה בשכיבה צידית", // Removed "לירכיים" as it’s redundant
  "Lunge": "לאנג'",
  "kneeling one arm pulldown": "משיכה חד-זרועית בברכיים",
  "Dumbbell Bench Squat": "סקווט עם משקולת ליד ספסל", // Clarified as a squat near a bench
  "Kneeling hip flexor stretch": "מתיחת כופפי ירך בברכיים", // Changed "מפשעה" to specify hip flexors
  "Side Lunge Stretch": "מתיחת לאנג' צידי",
  "Machine seated hip abduction": "הרחקת ירך בישיבה במכונה",
  "Single leg glute bridge": "גשר ישבן חד-רגלי",
  "Reverse Lunge": "לאנג' אחורי",
  "Barbell lunge": "לאנג' עם מוט",
  "Deep Squat": "סקווט עמוק", // Corrected from "סומו עמוק" to distinguish from Sumo Squat
  "bent over hip extension": "הארכת ירך כפופה",
  "Dumbbell lunge": "לאנג' עם משקולת",
  "Dumbbell forward-leaning lunge": "לאנג' עם נטייה קדימה ומשקולת", // Adjusted for better phrasing
  "Barbell deadlift": "דדליפט עם מוט",
  "Stability ball V-pass": "מעבר V עם כדור יציבות",
  "Bent-knee oblique v-up": "V-up אלכסוני עם ברכיים כפופות",
  "Oblique Crunches – On The Floor": "קראנצ'ים אלכסוניים על הרצפה",
  "Dead Bug": "חיפושית מתה",
  "Swiss Ball Rollout": "גלגול כדור שווייצרי",
  "Vertical leg crunch": "קראנץ' רגליים אנכי",
  "Twisting crunch": "קראנץ' מסתובב",
  "Hanging leg raise": "הרמת רגליים בתלייה",
  "Crunch with stability ball leg raise": "קראנץ' עם הרמת רגליים וכדור יציבות",
  "Weighted stability ball side bend": "כיפוף צידי משוקלל עם כדור יציבות",
  "V-up": "V-up",
  "Crunch (hands overhead)": "קראנץ' (ידיים מעל הראש)",
  "Kneeling cable crunch": "קראנץ' כבלים בברכיים",
  "Crunch (arms straight)": "קראנץ' (זרועות ישרות)",
  "Crunch Floor": "קראנץ' על הרצפה", // Simplified from "רצפה"
  "Frog crunch": "קראנץ' צפרדע",
  "Decline sit-up": "סיט-אפ בירידה",
  "Crunch (leg raise)": "קראנץ' (הרמת רגליים)",
  "Bicycle crunch": "קראנץ' אופניים",
  "Pistol Squat to Box": "סקווט פיסטול לקופסה",
  "Alternate Lying Floor Leg Raise": "הרמת רגליים לסירוגין בשכיבה על הרצפה",
  "Stability ball jackknife": "ג'קנייף עם כדור יציבות",
  "Sit-up": "סיט-אפ",
  "Cable one-arm reverse-grip triceps push-down": "דחיפת טריספס חד-זרועית עם אחיזה הפוכה וכבל",
  "Seated dumbbell overhead triceps extension": "הארכת טריספס מעל הראש בישיבה עם משקולת",
  "Seated bent-over two-arm dumbbell kickback": "קיקבק דו-זרועי בישיבה כפופה עם משקולות",
  "Triceps dip": "דיפ טריספס",
  "Reverse Grip Triceps Pushdown": "דחיפת טריספס עם אחיזה הפוכה",
  "Bent-knee bench dip": "דיפ ספסל עם ברכיים כפופות",
  "Triceps rope push-down": "דחיפת טריספס עם חבל",
  "One-arm dumbbell preacher curl": "כפיפת מרפקים פריצ'ר חד-זרועי עם משקולת",
  "Dumbbell one-arm reverse wrist curl": "כפיפת מרפקים שורש כף יד הפוך חד-זרועי עם משקולת",
  "Behind-the-back barbell wrist curl": "כפיפת מרפקים שורש כף יד מאחורי הגב עם מוט",
  "Cable curl": "כפיפת מרפקים עם כבל",
  "Seated barbell wrist curl": "כפיפת מרפקים שורש כף יד בישיבה עם מוט",
  "Dumbbell curl": "כפיפת מרפקים עם משקולת",
  "Dumbbell reverse curl": "כפיפת מרפקים הפוך עם משקולת",
  "Barbell reverse curl": "כפיפת מרפקים הפוך עם מוט",
  "EZ bar reverse curl": "כפיפת מרפקים הפוך עם מוט EZ",
  "Barbell skull crusher": "סקאל קראשר עם מוט",
  "Barbell JM press": "לחיצת JM עם מוט", // Corrected word order
  "Close-grip EZ bar curl": "כפיפת מרפקים צמוד עם מוט EZ",
  "Overhead EZ bar triceps extension": "הארכת טריספס מעל הראש עם מוט EZ",
  "Swiss Ball Lying Triceps Extension": "הארכת טריספס בשכיבה על כדור שווייצרי",
  "EZ bar curl": "כפיפת מרפקים עם מוט EZ",
  "Dumbbell hammer preacher curl": "כפיפת מרפקים פטיש פריצ'ר עם משקולת",
  "Tate press": "לחיצת טייט",
  "Cable triceps kickback": "קיקבק טריספס עם כבל",
  "Close-grip push-up": "שכיבות סמיכה צמודות",
  "Dumbbell kickback": "קיקבק עם משקולת",
  "Dumbbell One-Arm Triceps Extension Instructions": "הארכת טריספס חד-זרועית עם משקולת",
  "Dumbbell Seated Revers grip Concentration Curl": "כפיפת מרפקים ריכוז בישיבה עם אחיזה הפוכה ומשקולת",
  "Dumbbell Kickbacks on Exercise Ball": "קיקבק עם משקולת על כדור אימון",
  "Freedom Band Pushdown": "דחיפה עם רצועת חופש",
  "Glute Bridge on floor": "גשר ישבן על הרצפה",
  "Prone incline wide-grip upright row": "חתירה אנכית רחבה בשכיבה על ספסל משופע",
  "Barbell Clean and Press": "קלין ולחיצה עם מוט", // Adjusted "אנד" to "ו"
  "Barbell shrug": "שרג עם מוט",
  "Bent-over dumbbell row": "חתירה כפופה עם משקולות",
  "One-leg hyperextension": "הארכת גב חד-רגלית",
  "Standing cable rear delt row with rope": "חתירת דלתא אחורית בעמידה עם חבל",
  "wide front grip lat pull downs": "משיכות לאט רחבות עם אחיזה קדמית",
  "two arm dumbbell rows": "חתירה דו-זרועית עם משקולות",
  "Keiser twist (down up)": "טוויסט קייזר (למטה-למעלה)",
  "Freedom Pull Apart": "משיכה חופשית",
  "Capol over rear lateral raise": "הרמה צידית אחורית מעל הראש", // Assuming "Capol" is a typo or brand
  "Hyperextension Bench Exercise": "תרגיל הארכת גב על ספסל",
  "Pull-up": "מתח",
  "Bent-over two-arm dumbbell row": "חתירה כפופה דו-זרועית עם משקולות",
  "Underhand Yates row": "חתירת ייטס עם אחיזה תחתית",
  "Ankle – Dorsal Flexion": "פשיטת קרסול",
  "Machine seated calf raise": "הרמת עגלים בישיבה במכונה",
  "Mountain Climbers": "מטפסי הרים",
  "High bird dog plank": "פלאנק ציפור-כלב גבוה",
  "Band twist (up down)": "טוויסט עם רצועה (למעלה-למטה)",
  "Stability ball decline push-up": "שכיבות סמיכה בירידה עם כדור יציבות",
  "One-leg push-up": "שכיבות סמיכה חד-רגלית",
  "Incline dumbbell fly": "פלי משקולות בשיפוע",
  "Isometric wiper": "וויפר איזומטרי",
  "Front Dumbbell Raise": "הרמת משקולות קדמית",
  "Machine fly": "פלי במכונה",
  "Dumbbell fly": "פלי עם משקולות",
  "Decline dumbbell bench press": "לחיצת חזה בירידה עם משקולות",
  "Dumbbell bench press": "לחיצת חזה עם משקולות",
  "Cable crossovers": "קרוסאובר עם כבלים",
  "high fly": "פלי גבוה",
  "Incline barbell bench press": "לחיצת חזה בשיפוע עם מוט",
  "Decline barbell bench press": "לחיצת חזה בירידה עם מוט",
  "Push up (on knees)": "שכיבות סמיכה (על הברכיים)",
  "Push up (bosu ball)": "שכיבות סמיכה (על כדור בוסו)",
  "Push-ups": "שכיבות סמיכה",
  "Kettlebell swing": "נפת קטלבל",
  "Decline dumbbell fly": "פלי בירידה עם משקולות",
  "Weighted push-up": "שכיבות סמיכה משוקללות",
  "Stability ball push-up": "שכיבות סמיכה עם כדור יציבות",
  "Seated dumbbell overhead press": "לחיצת כתפיים מעל הראש בישיבה עם משקולות",
  "Behind-the-neck barbell overhead press": "לחיצת כתפיים מעל הראש מאחורי הצוואר עם מוט",
  "Smith machine shrug": "שרג במכונת סמית'",
  "Dumbbell w-press": "לחיצת W עם משקולות",
  "Cable front raise": "הרמה קדמית עם כבל",
  "Cable one-arm front raise": "הרמה קדמית חד-זרועית עם כבל",
  "Dumbbell Arnold Press": "לחיצת ארנולד עם משקולות",
  "Weighted Front Raise": "הרמה קדמית משוקללת",
  "Seated alternating dumbbell front raise": "הרמה קדמית לסירוגין בישיבה עם משקולות",
  "Barbell wide-grip upright row": "חתירה אנכית רחבה עם מוט",
  "One-arm dumbbell bent-over lateral raise": "הרמה צידית חד-זרועית כפופה עם משקולת",
  "Alternating dumbbell front raise": "הרמה קדמית לסירוגין עם משקולות",
  "Seated dumbbell front raise": "הרמה קדמית בישיבה עם משקולות",
  "Dumbbell lateral raise": "הרמה צידית עם משקולות",
  "Deltoid Raise": "הרמת דלתואיד",
  "Shoulder Press": "לחיצת כתפיים",
  "Double cable front raise": "הרמה קדמית כפולה עם כבלים",
  "Barbell Upright Row": "חתירה אנכית עם מוט",
  "Lying dumbbell one-arm rear lateral raise": "הרמה צידית אחורית חד-זרועית בשכיבה עם משקולת",
  "Πιέσεις με αλτήρες για ώμους – όρθια στάση": "לחיצת כתפיים עם משקולות בעמידה",
  "Dumbbell one-arm overhead press": "לחיצת כתפיים חד-זרועית מעל הראש עם משקולת",
  "Seated barbell overhead press": "לחיצת כתפיים מעל הראש בישיבה עם מוט",
  "Dumbbell Cuban rotation": "רוטציה קובנית עם משקולת",
  "Εμπρόσθιες άρσεις ώμων με μπάρα": "הרמות קדמיות לכתפיים עם מוט",
  "Lying dumbbell rear lateral raise": "הרמה צידית אחורית בשכיבה עם משקולת",
  "Έξω στροφή ώμου με τον ώμο σε 90 μοίρες απαγωγή": "סיבוב חיצוני של הכתף ב-90 מעלות אבדוקציה",
  "Cable external shoulder rotation": "סיבוב חיצוני של הכתף עם כבל",
  "Dumbbell Scott press": "לחיצת סקוט עם משקולת",
  "Άρσεις τραπεζοειδών με μπάρα": "הרמות טרפז עם מוט",
  "Dumbbell bent-over lateral raise": "הרמה צידית כפופה עם משקולת",
  "Seated bent-over lateral raise": "הרמה צידית כפופה בישיבה",
  "Barbell overhead press": "לחיצת כתפיים מעל הראש עם מוט",
  "Barbell Romanian Deadlift": "דדליפט רומני עם מוט",
  "Kettlebell Goblet Squat": "סקווט גביע עם קטלבל",
  "Standing Calf Raise": "הרמת עגלים בעמידה",
  "Seated Calf Raise": "הרמת עגלים בישיבה",
  "Dumbbell Romanian Deadlift": "דדליפט רומני עם משקולות",
  "Side Plank": "פלאנק צידי",
  "Plank": "פלאנק",
  "Russian Twist": "טוויסט רוסי",
  "Weighted Plank": "פלאנק משוקלל",
  "Cable Woodchopper": "חוטב עצים עם כבל",
  "Leg Press": "לחיצת רגליים",
  "Hack Squat": "סקווט האק",
  "Dumbbell Goblet Squat": "סקווט גביע עם משקולת",
  "Box Jump": "קפיצה לקופסה",
  "Step-Up": "עליית מדרגה",
  "Farmer’s Walk": "הליכת חוואי",
  "Wall Sit": "ישיבה על הקיר",
  "Reverse Hyper": "היפר הפוך",
  "Glute Kickback": "קיקבק ישבן",
  "Donkey Calf Raise": "הרמת עגלים דונקי",
  "Seated Leg Curl": "כפיפת רגליים בישיבה",
  "Lying Leg Curl": "כפיפת רגליים בשכיבה",
  "Nordic Hamstring Curl": "כפיפת רגליים נורדית",
  "Barbell Bench Press": "לחיצת חזה עם מוט",
  "Incline Push-Up": "שכיבות סמיכה בשיפוע",
  "Dumbbell Pullover": "פולאובר עם משקולת",
  "Chest Press Machine": "מכונת לחיצת חזה",
  "Pec Deck": "פק דק",
  "Barbell Incline Bench Press": "לחיצת חזה בשיפוע עם מוט",
  "Close-Grip Bench Press": "לחיצת חזה צמודה עם מוט",
  "Dumbbell Incline Press": "לחיצת חזה בשיפוע עם משקולות",
  "Lat Pulldown": "משיכות לאט",
  "Seated Row": "חתירה בישיבה",
  "T-Bar Row": "חתירת T-Bar",
  "Face Pull": "פייס פול",
  "Dumbbell Shrug": "שרג עם משקולות",
  "Barbell Curl": "כפיפת מרפקים עם מוט",
  "Hammer Curl": "כפיפת מרפקים פטיש",
  "Concentration Curl": "כפיפת מרפקים ריכוז",
  "Preacher Curl": "כפיפת מרפקים פריצ'ר",
  "Triceps Pushdown": "דחיפת טריספס",
  "Overhead Dumbbell Triceps Extension": "הארכת טריספס מעל הראש עם משקולת",
  "Dips": "דיפס",
  "Chin-Up": "מתח עם אחיזה תחתית",
  "Barbell Shoulder Press": "לחיצת כתפיים עם מוט",
  "Side Lateral Raise": "הרמה צידית",
  "Rear Delt Fly": "פלי דלתא אחורי",
  "Upright Row": "חתירה אנכית",
  "Assisted Chin up": "מתח בסיוע",
  "Barbell Clean Deadlift": "דדליפט בסגנון קלין עם מוט", // Adjusted for clarity
  "Barbell JM Press": "לחיצת JM עם מוט",
  "Bent-Over Barbell Reverse Raise (Shoulders)": "הרמה צידית אחורית כפופה עם מוט", // Specified as rear lateral raise
  "Bent-Over Two-Arm Dumbbell Row": "חתירה כפופה דו-זרועית עם משקולות",
  "Cable External Shoulder Rotation": "סיבוב חיצוני של הכתף עם כבל",
  "Cable Standing Rear Delt Horizontal Row": "חתירת דלתא אחורית אופקית עם כבל בעמידה",
  "Dumbbell Cuban Rotation": "רוטציה קובנית עם משקולת",
  "Dumbbell Scott Press": "לחיצת סקוט עם משקולת",
  "Dumbbell Seated Reverse Grip Concentration Curl": "כפיפת מרפקים ריכוז בישיבה עם אחיזה הפוכה ומשקולת",
  "Gripless shrug": "שרג ללא אחיזה",
  "High Bird Dog Plank": "פלאנק ציפור-כלב גבוה",
  "Kettlebell Kneeling One Arm Bottoms Up Press": "לחיצת חד-זרועית עם קטלבל בברכיים (תחתית למעלה)",
  "Lever Bent over Row (plate loaded)": "חתירה כפופה עם מכונה (טעינת משקולות)",
  "Lying Dumbbell One-Arm Rear Lateral Raise": "הרמה צידית אחורית חד-זרועית בשכיבה עם משקולת",
  "Lying Dumbbell Rear Lateral Raise": "הרמה צידית אחורית בשכיבה עם משקולת",
  "One-Arm Dumbbell Bent-Over Lateral Raise": "הרמה צידית חד-זרועית כפופה עם משקולת",
  "Seated Alternating Dumbbell Front Raise": "הרמה קדמית לסירוגין בישיבה עם משקולות",
  "Seated Bent-Over Lateral Raise": "הרמה צידית כפופה בישיבה",
  "Spider Crawl Push up": "שכיבות סמיכה זחילה עכבישית",
  "Standing Long Jump (female)": "קפיצה לרוחק בעמידה (נשים)",
  "Underhand Yates Row": "חתירת ייטס עם אחיזה תחתית",
  "Sumo Squat": "סקווט סומו", // Corrected from "סומו עמוק" to distinguish from Deep Squat
  "45-Degree Leg Press": "לחיצת רגליים 45 מעלות",
  "Lying Hip Thrusts with Bent Knees": "דחיפת ירך בשכיבה עם ברכיים כפופות", // Aligned with "hip thrust" terminology
  "Standing Triceps Extensions with Barbell": "הארכת טריספס בעמידה עם מוט",
  "Close-Grip Lat Pulldowns": "משיכות לאט עם אחיזה צמודה", // Corrected typo "תרווחליה"
  "Bent-Over Barbell Row": "חתירה כפופה עם מוט",
  "Trap Raises with Cable": "הרמות טרפז עם כבל", // Corrected "תרווחליה" to "כבל"
  "Dumbbell Shoulder Press – Standing": "לחיצת כתפיים עם משקולות בעמידה",
  "Front Barbell Shoulder Raises": "הרמות קדמיות לכתפיים עם מוט",
  "External Shoulder Rotation with Shoulder at 90 Degrees Abduction": "סיבוב חיצוני של הכתף ב-90 מעלות אבדוקציה",
  "Barbell Trap Raises": "הרמות טרפז עם מוט"
};

const ExerciseCard = ({ exercise }) => (
  <Link className="exercise-card" to={`/exercise/${exercise._id}`}>
    {/* Display Exercise Image */}
    {exercise.gifUrl ? (
      <img src={exercise.gifUrl} alt={exercise.name} loading="lazy" />
    ) : (
      <p>No image available</p>
    )}

    {/* Muscle Group Information */}
    <Stack direction="row" mt={2}>
      <Button
        sx={{
          ml: '21px',
          color: '#fff',
          background: '#FFA9A9',
          fontSize: '14px',
          borderRadius: '20px',
          textTransform: 'capitalize',
        }}
      >
        {exercise.muscleGroup}
      </Button>
    </Stack>

    {/* Exercise Name */}
    <Typography
      ml="21px"
      color="#000"
      fontWeight="bold"
      sx={{ fontSize: { lg: '24px', xs: '20px' } }}
      mt="11px"
      pb="10px"
      textTransform="capitalize"
      direction="rtl"
      textAlign="right"
      fontFamily="GveretLevin"
    >
      {exerciseNameMapping[exercise.name] || exercise.name}
    </Typography>
  </Link>
);

export default ExerciseCard;